import locale from "csi/locale";
import { sessionStore } from "csi/state/rootStore";
import xml from "csi/xml";
import Search from "csi/xml/Search";
import { action } from "mobx";
import { clearAggregateStoreCaches } from "src/c8-platform/service/aggregateStoreService";

const PROOF_TASK = "ProofTask";
const PROOF_TASK_DEFINITION = "ProofTaskDefinition";

// ProofTask-s have 'ProofTaskViewer', 'ProofTaskReviewer' and 'ProofTaskApprover' names. Localize them
locale.registerDisplayNameResolver(PROOF_TASK, (node) => locale.resource(node.$Name));

// Convert ProofTaskDefinition names (Viewer, Reviewer, Approver)
// into 'ProofTaskViewer', 'ProofTaskReviewer' and 'ProofTaskApprover'.
// Then localize them
locale.registerDisplayNameResolver(PROOF_TASK_DEFINITION, (node) => locale.resource("ProofTask" + node.$Name));

/** clear the aggregate store cache to get the fresh one once making changes to task definition */
export function postActionProofTaskDefinition(ac): void {
	clearAggregateStoreCaches();
}

/** clear the aggregate store cache to get the fresh one once editing the role  */
export function postActionManageRole(ac): void {
	ac.widget.postActionRedrawNode(ac);
	clearAggregateStoreCaches();
}

export function postActionProofStageLock(ac): void {
	ac.widget.beginProofTaskAction();
}

/**
 * Get ProofTasks list for current user
 */
export function proofingUpdateAssignedTaskCount(): void {
	const currentUserUrl = sessionStore.userUrl;
	const search = new Search()
		.useCountOperation()
		.byType(PROOF_TASK);
	search.getQuery()
		.RefAttr("Assignee", xml.OP_EQUALS, currentUserUrl)
		.Attr("IsRunning", xml.OP_EQUALS, true);

	search.execute()
		.then(action((response) => {
			sessionStore.proofingAssignedTaskCount = ~~response.data.TotalCount;
		}));
}
